'use client';

import React from 'react';
import { IoMdClose, IoIosArrowDown, IoIosArrowUp } from 'react-icons/io';
import { useTekstClient } from 'hooks/useTekstClient';

export default function ActiveFiltersSection({
    styles,
    activeFilterCount,
    activeFiltersExpanded,
    onToggleExpanded,
    activeFiltersList,
    onResetAll,
    onRemoveSingleFilter,
}) {
    const { tekst } = useTekstClient();
    if (activeFilterCount <= 0) return null;

    return (
        <div className={styles.activeFiltersSection}>
            <button
                type="button"
                className={styles.filterHeader}
                onClick={onToggleExpanded}
                aria-expanded={activeFiltersExpanded}
            >
                {activeFiltersExpanded ? <IoIosArrowUp /> : <IoIosArrowDown />}
                <span>{tekst('mkgeu:mkgaddons:activefilters:title')}</span>
            </button>
            {activeFiltersExpanded && (
                <div className={styles.activeFiltersContent}>
                    <div className={`${styles.activeFilterItem} ${styles.clearAllFiltersItem}`}>
                        <button
                            type="button"
                            className={styles.activeFilterBtn}
                            onClick={onResetAll}
                        >
                            <span className={styles.activeFilterRemove}>
                                <IoMdClose />
                            </span>
                            <span className={styles.activeFilterName}>
                                {tekst('mkgeu:mkgaddons:activefilters:clearcount', {
                                    count: activeFilterCount,
                                    type: tekst('mkgeu:mkgaddons:filters:label:filter', null, activeFilterCount),
                                })}
                            </span>
                        </button>
                    </div>
                    <ul className={`${styles.activeFiltersList} list-none`}>
                        {activeFiltersList.map((item) => (
                            <li key={`${item.slug}-${item.subfilterId}`} className={styles.activeFilterItem}>
                                <button
                                    type="button"
                                    className={styles.activeFilterBtn}
                                    onClick={() => onRemoveSingleFilter(item.slug, item.subfilterId)}
                                    aria-label={tekst('mkgeu:mkgaddons:activefilters:aria:removefilter', { name: item.subfilterNaam })}
                                >
                                    <span className={styles.activeFilterRemove}>
                                        <IoMdClose />
                                    </span>
                                    <span className={styles.activeFilterName}>
                                        {item.subfilterNaam}
                                    </span>
                                </button>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
